import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { BsGithub } from "react-icons/bs";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import ytdownloader from "../../Assets/Projects/ytdownloader.png";
import gitops from "../../Assets/Projects/gitops.jpg";
import logmetrix from "../../Assets/Projects/logmetrix.png";
import clipbotic from "../../Assets/Projects/clipbotic.png";
import studybuddy from "../../Assets/Projects/studybuddy.png";

const subtitleStyle = { color: "white", textAlign: "center" };
const cardRowStyle = { justifyContent: "center", paddingBottom: "10px" };
const githubButtonWrapperStyle = {
  textAlign: "center",
  marginTop: "20px",
  position: "relative",
  zIndex: "1",
};

const PROJECTS = [
  {
    imgPath: ytdownloader,
    title: "YT Downloader",
    description:
      "YtDownloader is a Flask-based REST API that retrieves YouTube video information while demonstrating modern DevOps practices. The project features a complete CI/CD pipeline using Jenkins, Docker containerization, Kubernetes deployment with autoscaling, and Prometheus monitoring, making it both a functional tool and a showcase of cloud-native development workflows.",
    ghLink: "https://github.com/iamdheerajjain/YtDownloader",
  },
  {
    imgPath: gitops,
    title: "GitOps",
    description:
      "This project demonstrates a complete GitOps workflow using ArgoCD for automated Kubernetes deployments on a local Kind cluster. It showcases continuous delivery practices where Git serves as the single source of truth, with integrated monitoring through Prometheus and Grafana for observability and visualization of cluster metrics.",
    ghLink: "https://github.com/iamdheerajjain/gitops",
  },
  {
    imgPath: logmetrix,
    title: "LogMetrix",
    description:
      "LogMetrix is a lightweight, open-source monitoring and observability stack built on Fedora Linux that integrates Prometheus for metrics collection, Grafana for visualization, Loki for log aggregation, and Promtail for log shipping. It provides a complete self-hosted monitoring solution ideal for DevOps environments and learning projects.",
    ghLink: "https://github.com/iamdheerajjain/LogMetrix",
  },
  {
    imgPath: clipbotic,
    title: "Clipbotic",
    description:
      "Clipbotic is an AI-powered tool that automatically generates YouTube shorts from any topic using Google Gemini for scripts, Deepgram for voiceovers, and AI-generated visuals with auto-timed captions, built with Next.js and Remotion.Retry.",
    ghLink: "https://github.com/iamdheerajjain/Clipbotic",
  },
  {
    imgPath: studybuddy,
    title: "Study Buddy",
    description:
      "StudyBuddy is an AI-powered tutoring app with a Flask backend providing RAG-based document analysis, web search, image/video processing, and speech features, paired with a Next.js frontend that proxies requests to deliver an intelligent learning assistant.",
    ghLink: "https://github.com/iamdheerajjain/StudyBuddy",
  },
];

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={subtitleStyle}>Here are a few projects I've worked on.</p>
        <Row style={cardRowStyle}>
          {PROJECTS.map((project) => (
            <Col md={4} className="project-card" key={project.title}>
              <ProjectCard {...project} />
            </Col>
          ))}
        </Row>
      </Container>
      <h1 className="project-heading">
        Link to my <strong className="purple">Github </strong>
      </h1>
      <p style={subtitleStyle}>View my entire codebase</p>
      <div style={githubButtonWrapperStyle}>
        <Button
          variant="primary"
          href="https://github.com/iamdheerajjain"
          target="_blank"
        >
          <BsGithub /> &nbsp;
          {"GitHub"}
        </Button>
      </div>
    </Container>
  );
}

export default React.memo(Projects);
